import React from 'react';
import { DialogActions } from '@mui/material';


export const HDialogActions = ({ children, ...restProps }) => (
  <DialogActions {...restProps}>
    {children}
  </DialogActions>
);
